import { render } from "./BannerSlider.vue?vue&type=template&id=67842418&scoped=true"
import script from "./BannerSlider.vue?vue&type=script&lang=js"
export * from "./BannerSlider.vue?vue&type=script&lang=js"

import "./BannerSlider.vue?vue&type=style&index=0&id=67842418&scoped=true&lang=css"

import exportComponent from "/Users/wadayuki/Desktop/anone/anone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67842418"]])

export default __exports__